import { z } from 'zod';

export const PushNotificationConfigSchema = z.object({
  token: z.string(),
  provider: z.enum(['fcm']),
});

export type PushNotificationConfig = z.infer<typeof PushNotificationConfigSchema>;
